<template>
  <div class="login">
    <div class="main-title">
      <h2>Log ind</h2>
    </div>
    <div class="login-form">
      <form v-on:submit.prevent="login">
        <div class="forgot-link"> <p>Glemt din adgangskode? <a :href="'#/password-forgot'"> forny her.</a></p></div>
        <div class="form">
          <div>
            <input-type v-bind:value="username" v-on:input="username = $event" type="text" label="E-mail adresse" placeholder="E-mail" autocomplete="email"></input-type>
          </div>
          <div>
            <input-password v-bind:value="password" v-on:input="password = $event" label="Adgangskode" placeholder="Adgangskode"></input-password>
          </div>
        </div>
        <div class="btn-box">
          <input :class="{loading: loading}" class="update-btn" type="submit" value="Log ind" />
          <div v-if="errorMessage != ''" class="error-message">{{ errorMessage }}</div>
        </div>
      </form>
      <div class="register-link">
        <a :href="'#/register'"><span style="color: black">Ny bruger?</span> Opret din profil</a>
      </div>
    </div>
    <div v-if="$texts.sidebarTextLogin" v-html="$texts.sidebarTextLogin" class="sidebar-text"></div>
  </div>
</template>

<script>
import InputType from '../Inputs/InputType'
import InputPassword from '../Inputs/Password'

export default {
  name: 'Login',

  components: {
    'input-type': InputType,
    'input-password': InputPassword,
  },

  data() {
    return {
      loading: false,
      errorMessage: '',
      username: '',
      password: '',
    }
  },

  methods: {
    login() {
      this.loading = true
      this.$cashback
        .login(this.username, this.password, this.$settings.publisherClientId)
        .then((data) => {
          let login = '/authenticate/?expires_in=' + data.expires_in

          return fetch(login, {
            method: 'POST',
            redirect: 'follow',
            headers: {
              Authorization: 'Bearer ' + data.access_token,
            },
          })
        })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.statusText)
          }

          window.location.href = response.url
        })
        .catch((error) => {
          this.loading = false
          this.errorMessage = error.toString().substr(7)

          setTimeout(() => {
            this.errorMessage = ''
          }, 6000)
        })
    },
  },
}
</script>
